import $ from "jquery";
import MicroModal from "micromodal";

const SELECTOR_TRIGGER = '[data-js="jsEmailModalTrigger"]';
const SELECTOR_MODAL_CONTENT = "#modal-3-content";
const SELECTOR_MODAL_CONFIRM = "#modal-3-confirm";
const ID_MODAL = "modal-3";

$(document).on("click", SELECTOR_TRIGGER, function (e) {
  if ($(SELECTOR_MODAL_CONTENT).length !== 0) {
    e.preventDefault();

    $(SELECTOR_MODAL_CONFIRM).attr("href", e.target.href);

    MicroModal.show(ID_MODAL);
  }
});
